"use client";

import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { useFormikContext } from "formik";
import React, { Children } from "react";

import kebabToCamelCase from "@shared/functions/kebabToCamelCase";

import {
  type CommonTileProps,
  createTileClassNames,
} from "./common-tile-resources";

interface StackedTileProps extends CommonTileProps {
  icon: React.ReactNode;
}

interface TileWrapperProps {
  children: React.ReactNode;
}
export function StackedTileWrapper({ children }: TileWrapperProps) {
  if (Children.count(children) < 2 || Children.count(children) > 3) {
    throw Error(
      `Invalid number of tiles - must be two or 3; number of children = ${Children.count(children)}`,
    );
  }
  const classNames = clsx({
    [`stacked-tiles-wrapper`]: true,
    [`stacked-tiles-wrapper--two`]: Children.count(children) == 2,
    [`stacked-tiles-wrapper--three`]: Children.count(children) == 3,
  });
  return <div className={classNames}>{children}</div>;
}
export function StackedTile({
  className,
  color,
  icon,
  label,
  componentStyle,
  value,
  ...props
}: StackedTileProps) {
  const classNames = createTileClassNames(
    { className, color, componentStyle },
    "stacked",
  );

  const formikContext = useFormikContext<any>();

  const fieldName = formikContext
    ? kebabToCamelCase(formikContext?.values.stepName)
    : "";

  let loading = false;

  if (
    formikContext?.isSubmitting &&
    formikContext?.values[fieldName] == value
  ) {
    loading = true;
  }

  if (loading) {
    icon = <FontAwesomeIcon icon={faSpinner} spin />;
  }

  return (
    <button
      disabled={loading}
      type="submit"
      className={classNames}
      value={value}
      {...props}
    >
      {icon && <span className="tile__icon">{icon}</span>}
      <span
        className="tile__label"
        dangerouslySetInnerHTML={{ __html: label || "" }}
      />
    </button>
  );
}
